/**
 * Datos corporativos y legales (un solo lugar para actualizar dominio/correos).
 * Dominio efectivo del sitio: DreamVinyl.es (producción Vercel).
 */

/** URL canónica sin barra final (compartir, kits redes, referidos, emails). */
export const CANONICAL_SITE_ORIGIN = 'https://dreamvinyl.es';

export function isLocalDevHostname(hostname) {
  const h = String(hostname ?? '').toLowerCase();
  return h === 'localhost' || h === '127.0.0.1';
}

/**
 * Base pública para enlaces compartidos y callbacks Stripe en producción.
 * - Vercel / dreamvinyl.es → siempre CANONICAL (o REACT_APP_PUBLIC_SITE_URL).
 * - `npm start` local → origin del dev server (OAuth/Stripe test).
 */
export function getPublicSiteBase() {
  const fromEnv = process.env.REACT_APP_PUBLIC_SITE_URL;
  if (fromEnv && String(fromEnv).trim()) {
    return String(fromEnv).trim().replace(/\/+$/, '');
  }
  if (typeof window !== 'undefined' && isLocalDevHostname(window.location.hostname)) {
    return String(window.location.origin).replace(/\/+$/, '');
  }
  return CANONICAL_SITE_ORIGIN;
}

/** Redirect de Supabase Auth (registro, OAuth, recuperar contraseña). */
export function getAuthRedirectBase() {
  const base = getPublicSiteBase().replace(/\/+$/, '');
  return `${base}/`;
}

export const SITE_CONFIG = {
  nombre: 'DreamVinyl',
  dominio: 'dreamvinyl.es',
  urlPublica: CANONICAL_SITE_ORIGIN,
  emailContacto: 'contacto@dreamvinyl.es',
  emailSoporte: 'soporte@dreamvinyl.es',
  emailLegal: 'legal@dreamvinyl.es',
  emailColaboraciones: 'colaboraciones@dreamvinyl.es',
  emailProfesionales: 'profesionales@dreamvinyl.es',
  /** Razón social / titular mostrado en pie y legales (provisional hasta textos definitivos). */
  titular: 'DreamVinyl',
  ciudad: 'Ciudad Real',
  paisTitular: 'España',
  fechaActualizacionLegal: 'mayo de 2026',
  /** Muestra aviso en páginas legales de que los textos están pendientes de revisión jurídica. */
  legalTextsProvisional: true,
};
